class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('.quantity__input')
    this.changeEvent = new Event('change', { bubbles: true })
    //on quantity load check for restrictions
    if (
      this.input.value >=
      this.querySelector('input[name="quantity-restriction"]').value
    ) {
      if (this.querySelector('input[name="quantity-restriction"]').value >= 2) {
        this.querySelector('button[name="plus"]').disabled = true
      } else {
        this.querySelector('button[name="plus"]').disabled = false
      }
    }

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value
    //on button click check for restrictions
    if (this.querySelector('input[name="quantity-restriction"]')) {
      if (
        this.input.value >=
        this.querySelector('input[name="quantity-restriction"]').value
      ) {
        this.querySelector('button[name="plus"]').disabled = true
      } else {
        this.querySelector('button[name="plus"]').disabled = false
      }
    }

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)
